import { Box, Card, Divider, Stack, styled, Typography } from '@mui/material';
import { COLOR_PRIMARY, useBreakpoints } from 'shared';

const IntroCardStyled = styled(Card)(({ theme }) => ({
  width: 'fit-content',
  padding: theme.spacing(2.5, 0.5),
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
    width: '100%',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

const IntroCardColumn = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  alignItems: 'center',
  width: 204,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const IntroCard = () => {
  const { isDownSmLayout } = useBreakpoints();

  return (
    <IntroCardStyled className="blur">
      <IntroCardColumn>
        <Typography variant="h6" className="secondary medium">
          IP Protection in
        </Typography>
        <Typography variant="h5" className="no-resize accent">
          181 Countries
        </Typography>
        <Typography variant="h6" className="secondary medium">
          Reg. No.{' '}
          <Box component="span" sx={{ color: COLOR_PRIMARY, whiteSpace: 'nowrap' }}>
            EC-01-004149
          </Box>
        </Typography>
      </IntroCardColumn>
      {!isDownSmLayout ? (
        <Divider
          orientation="vertical"
          sx={{
            height: '69px',
          }}
        />
      ) : (
        <Divider
          orientation="horizontal"
          sx={{
            width: '100%',
          }}
        />
      )}
      <IntroCardColumn>
        <Typography variant="h6" className="secondary medium">
          IP Valuation:
        </Typography>
        <Typography variant="h5" className="no-resize accent">
          $160,255,384.00
        </Typography>
        <Typography variant="h6" className="medium">
          London Rate
        </Typography>
      </IntroCardColumn>
    </IntroCardStyled>
  );
};
